import React, { useEffect, useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import useAxios from '../../../../api/useAxios';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  Row,
  Col,
  Alert,
} from 'reactstrap';
import showToast from '../../../../utils/toast-types';

const PRIORITY_FIELDS = ['skills', 'experience', 'education', 'job_type', 'location'];

const MatchingPriority = ({ activeTab }) => {
  const api = useAxios();

  const [priorities, setPriorities] = useState({
    skills: 1,
    experience: 1,
    education: 1,
    job_type: 1,
    location: 1,
  });

  const [message, setMessage] = useState({ type: '', text: '' });

  const { isLoading } = useQuery(
    'job-applicant-match-weight',
    () => api.get(`jobs/job-applicant-match-weight`),
    {
      enabled: activeTab === '7',
      onSuccess: (res) => {
        const data = res?.data;
        if (data) {

          setPriorities({
            skills: data?.skills ?? 1,
            experience: data?.experience ?? 1,
            education: data?.education ?? 1,
            job_type: data?.job_type ?? 1,
            location: data?.location ?? 1,
          });
        }
      },
      onError: () => {
        setMessage({ type: 'danger', text: 'Failed to fetch priorities' });
      },
    }
  );

  const { mutate: updatePriorities, isLoading: isSaving } = useMutation(
    (newData) => api.post(`jobs/job-applicant-match-weight`, newData),
    {
      onSuccess: () => {
        showToast('Priorities updated successfully', 'success')
      },
      onError: () => {
        showToast('Failed to update priorities', 'error')
      },
    }
  );

  const handleChange = (field, value) => {
    setPriorities((prev) => ({ ...prev, [field]: parseInt(value) }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    updatePriorities(priorities);
  };

  return (
    <div className="p-3">

      {message.text && (
        <Alert color={message.type} toggle={() => setMessage({ type: '', text: '' })}>
          {message.text}
        </Alert>
      )}

      {isLoading ? (
        <Spinner color="primary" />
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            {PRIORITY_FIELDS.map((field) => (
              <Col md={6} className="mb-3" key={field}>
                <FormGroup>
                  <Label className="text-capitalize" for={field}>
                    {field.replace('_', ' ')}
                  </Label>
                  <Input
                    id={field}
                    type="select"
                    value={priorities[field]}
                    onChange={(e) => handleChange(field, e.target.value)}
                  >
                    {[1, 2, 3, 4, 5].map((val) => (
                      <option key={val} value={val}>
                        {val}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            ))}
          </Row>

          <Button type="submit" color="primary" disabled={isSaving}>
            {isSaving ? <Spinner size="sm" /> : 'Save Priorities'}
          </Button>
        </Form>
      )}
    </div>
  );
};

export default MatchingPriority;
